import type { BaseKeyFunction } from "../../../lib";

export const keyFamily: BaseKeyFunction = () => ["family"];
